import { cn } from '@/helpers/tailwind';
import { Arrow } from '@/atoms/00-ui/Arrow';
import { Typography } from '@/atoms/00-ui/Typography';
import { IButtonProps } from '@/molecules/00-ui/СonicButton/index.types';
import { TArrowColors } from '@/atoms/00-ui/Arrow/index.types';

export const ConicButton = ({
  testId,
  themeColor = 'pink',
  disabled = false,
  className,
  text,
  onClick,
  ...rest
}: IButtonProps) => {
  return (
    <button
      data-testid={testId}
      className={cn(
        'relative group px-[20px] py-[11px] overflow-hidden rounded-full bg-origin-border border-[1px] border-white/40',
        {
          ['border-0']: themeColor === 'white',
        },
        className,
      )}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      <span className="relative z-10 flex gap-x-[8px] items-center">
        <Typography
          component="span"
          variant="button"
          className={cn({
            ['text-black']: themeColor === 'white',
            ['text-white']: themeColor === 'green' || themeColor === 'black',
          })}
        >
          {text}
        </Typography>
        <Arrow
          themeColor={
            cn({
              gray: themeColor === 'white',
              white: themeColor === 'green' || themeColor === 'black',
            }) as TArrowColors
          }
        />
      </span>

      <span
        className={cn(
          `block group-hover:rotate-180 duration-500 absolute w-full scale-[1.1] will-change-[rotate]
           aspect-[1/2] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]`,
          {
            ['bg-conic-gradient-white-gray']: themeColor === 'white',
            ['bg-conic-gradient-green']: themeColor === 'green',
            ['bg-conic-gradient-dark-blue']: themeColor === 'black',
          },
        )}
      />
    </button>
  );
};
